import LoaderScene from "../scenes/LoaderScene";
import LoadBatches from "../utils/LoadBatches";
import LoadBatch from "./LoadBatch";

export default class LoadBatchManager {
	batches: Map<string, LoadBatch>;
	sceneBatches: Map<string, string>;

	constructor() {
		this.batches = new Map<string, LoadBatch>();
		this.sceneBatches = new Map<string, string>();
	}

	get(key: string): LoadBatch {
		if (!this.batches.has(key)) {
			const batch = new LoadBatch(key);
			this.batches.set(key, batch);
		}
		return this.batches.get(key);
	}

	setBatches(scene: string, batches: string): void {
		this.sceneBatches.set(scene, batches);
		console.log("set batches: " + scene + ", " + batches);
	}

	hasBatches(scene: string): boolean {
		return this.sceneBatches.has(scene);
	}

	getBatches(loaderScene: LoaderScene, destinationScene: string): LoadBatch[] {
		console.log("destination: " + destinationScene);
		const key = this.sceneBatches.get(destinationScene);
		console.log("key: " + key);
		return (<any>LoadBatchManager)[key](loaderScene);
	}
	loadBatch(loaderScene: LoaderScene, batch: LoadBatch, onLoaded?: () => void): void {
		batch.load(loaderScene, true, onLoaded);
	}

	loadBatchesForScene(loaderScene: LoaderScene, destinationScene: string): void {
		const batchesToLoad = this.getBatches(loaderScene, destinationScene);

		this.batches.forEach((batch: LoadBatch, _key: string): void => {
			if (batchesToLoad.find((b) => b == batch) == null) {
				batch.unload();
			}
		});

		for (const batch of batchesToLoad) {
			batch.load(loaderScene);
		}
	}

	private static GlobalBatches(): LoadBatch[] {
		const batches: LoadBatch[] = [];
		batches.push(LoadBatches.Global);
		batches.push(LoadBatches.Transition);
		return batches;
	}

	static MenuBatches(): LoadBatch[] {
		const batches: LoadBatch[] = [];
		batches.push(...this.GlobalBatches());
		batches.push(LoadBatches.Menu);
		return batches;
	}

	static GameplayBatches(scene: LoaderScene): LoadBatch[] {
		const batches: LoadBatch[] = [];
		batches.push(...this.GlobalBatches());
		batches.push(LoadBatches.Gameplay(scene));
		return batches;
	}
}
